import i18n from '../../../../app/i18n';

const action = {
  title: i18n.t('tileForm:interaction.types.action.title'),
  options: [
    {
      name: i18n.t('tileForm:interaction.types.action.options.readTile'),
      value: 'read_tile',
    },
    {
      name: i18n.t('tileForm:interaction.types.action.options.takeAction'),
      value: 'take_action',
    },
    {
      name: i18n.t('tileForm:interaction.types.action.options.readArticle'),
      value: 'read_article',
    },
    {
      name: i18n.t(
        'tileForm:interaction.types.action.options.shareOnSocialMedia',
      ),
      value: 'share_on_social_media',
    },
    {
      name: i18n.t('tileForm:interaction.types.action.options.visitWebsite'),
      value: 'visit_web_site',
    },
    {
      name: i18n.t('tileForm:interaction.types.action.options.watchVideo'),
      value: 'watch_video',
    },
    {
      name: i18n.t('tileForm:interaction.types.action.options.custom'),
      value: 'custom',
    },
  ],
};

const quiz = {
  title: i18n.t('tileForm:interaction.types.quiz.title'),
  options: [
    {
      name: i18n.t('tileForm:interaction.types.quiz.options.trueFalse'),
      value: 'true_false',
    },
    {
      name: i18n.t('tileForm:interaction.types.quiz.options.multipleChoice'),
      value: 'multiple_choice',
    },
  ],
};

const survey = {
  title: i18n.t('tileForm:interaction.types.survey.title'),
  options: [
    {
      name: i18n.t('tileForm:interaction.types.survey.options.multipleChoice'),
      value: 'multiple_choice',
    },
    {
      name: i18n.t('tileForm:interaction.types.survey.options.feedBack'),
      value: 'feedback',
    },
    {
      name: i18n.t('tileForm:interaction.types.survey.options.freeResponse'),
      value: 'free_response',
    },
    {
      name: i18n.t('tileForm:interaction.types.survey.options.rsvpToEvent'),
      value: 'rsvp_to_event',
    },
    {
      name: i18n.t('tileForm:interaction.types.survey.options.changeEmail'),
      value: 'change_email',
    },
    {
      name: i18n.t('tileForm:interaction.types.survey.options.inviteSpouse'),
      value: 'invite_spouse',
    },
  ],
};

const questionAnswer = {
  title: i18n.t('tileForm:interaction.types.questionAnswer.title'),
};

const tileText = {
  read_tile: i18n.t('tileForm:interaction.types.action.readTile.tileText'),
  take_action: i18n.t('tileForm:interaction.types.action.takeAction.tileText'),
  read_article: i18n.t(
    'tileForm:interaction.types.action.readArticle.tileText',
  ),
  share_on_social_media: i18n.t(
    'tileForm:interaction.types.action.shareOnSocialMedia.tileText',
  ),
  visit_web_site: i18n.t(
    'tileForm:interaction.types.action.visitWebsite.tileText',
  ),
  watch_video: i18n.t('tileForm:interaction.types.action.watchVideo.tileText'),
  custom: i18n.t('tileForm:interaction.types.action.custom.tileText'),
  true_false: i18n.t('tileForm:interaction.types.quiz.true_false.tileText'),
  multiple_choice: i18n.t(
    'tileForm:interaction.types.quiz.quiz_multiple_choice.tileText',
  ),
  feedback: i18n.t('tileForm:interaction.types.survey.feedback.tileText'),
  free_response: i18n.t(
    'tileForm:interaction.types.survey.free_response.tileText',
  ),
  rsvp_to_event: i18n.t(
    'tileForm:interaction.types.survey.rsvp_to_event.tileText',
  ),
  change_email: i18n.t(
    'tileForm:interaction.types.survey.change_email.tileText',
  ),
  invite_spouse: i18n.t(
    'tileForm:interaction.types.survey.invite_spouse.tileText',
  ),
  question_answer: i18n.t('tileForm:interaction.types.questionAnswer.tileText'),
};

export { action, quiz, survey, questionAnswer, tileText };
